import { render } from "./Video.vue?vue&type=template&id=58a3aeea&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=58a3aeea&lang=scss&scoped=true"

import exportComponent from "/builds/rgLPqy5NH/0/rockwool/super-wykonawca-2022/performer-rating-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a3aeea"]])

export default __exports__